'use client'
import { useGetHubSelected } from '@core/auth/hooks'
import useProfile from '@core/auth/hooks/use-profile/use-profile.hook'
import { hubHandler } from '@core/auth/utils'
import { rum } from '@core/observability'
import { unleashClient } from '@core/unleash/unleash-client'
import { useStartUnleash } from '@core/unleash/use-unleash-start.hook'
import { getUserPermission } from '@utils/permissions'
import { usePathname, useRouter } from 'next/navigation'
import { PropsWithChildren, useEffect } from 'react'

const REDIRECT_PATH = '/sign-in'

export function UserSessionBootstrap({ children }: PropsWithChildren) {
  const { user, isLoading, fetchUserProfile } = useProfile()
  const startUnleashSdk = useStartUnleash()
  const { setDefaultHub, getHubsList } = hubHandler()
  const { hubId, hubSelected } = useGetHubSelected()
  const pathname = usePathname()

  const router = useRouter()
  const havePermission = user ? getUserPermission(user) : false
  const redirectToLoginScreen =
    !!user && !havePermission && !isLoading && !hubId

  useEffect(
    function redirectToLoginScreenHandler() {
      if (redirectToLoginScreen) {
        router.push(REDIRECT_PATH)
      }
    },
    [redirectToLoginScreen, pathname, router]
  )

  useEffect(
    function sendInfoToObservability() {
      if (Object.keys(rum.getUser()).length > 0) {
        return
      }

      const ddUser = user?.email
        ? {
            id: user?.email,
            name: user?.name,
            accessType: user?.permissions,
            hubsList: user?.hubIds,
            hubSelected: hubSelected,
          }
        : {}

      rum.setUser(ddUser)
    },
    [hubSelected, user]
  )

  useEffect(
    function startServiceWithUser() {
      if (user) {
        rum.startSessionReplayRecording()
      } else {
        unleashClient.stop()
      }
    },
    [user]
  )

  useEffect(
    function setUnleashHubID() {
      if (hubId) {
        startUnleashSdk(hubSelected)
      } else {
        unleashClient.stop()

        if (user && getHubsList()) {
          setDefaultHub()
        }
      }
    },
    [getHubsList, hubId, hubSelected, setDefaultHub, startUnleashSdk, user]
  )

  useEffect(() => {
    if (!user) {
      rum.stopSessionReplayRecording()
      unleashClient.stop()
      fetchUserProfile()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return children
}
